import React, { Component } from 'react'
import DataTable, { createTheme } from 'react-data-table-component';
import auth from "./auth"
import SignIn from './SignIn';
import {SignOutDirect, SignOut} from './SignOut';
import Checkbox from '@material-ui/core/Checkbox';

const selectProps = { indeterminate: isIndeterminate => isIndeterminate };


class Dashboard extends Component {

    constructor(props){
        super(props);

        this.state = {
            columns: [
       
                {
                  name: 'Datum',
                  selector: 'date',
                  sortable: true,
                },
                {
                    name: 'Tag',
                    selector: 'day',
                    sortable: true,
                },
                {
                    name: 'Titel',
                    selector: 'title',
                    sortable: true,
                },
                {
                    name: 'Zeit',
                    selector: 'time',
                    sortable: true,
                },
                {
                    name: 'Name',
                    selector: 'name',
                    sortable: true,
                },
                {
                    name: 'Email',
                    selector: 'email',
                    sortable: true,
                },
                {
                    name: 'ID',
                    selector: 'id',
                    sortable: false,
                },
                {
                    name: <button className="btn btn-danger" onClick={()=>{this.deleteBulkRecord()}}>Ausgewählte löschen</button>,
                    selector: 'action',
                    sortable: true,
                },
              ],
            data: [
                //{date: "17-11-2020", day:"Dienstag", title:"This is title", time:"10:30", action: <button>Delete</button> }
            ],
            headerColumn: [
            {
                name: 'Clear Rows',
                selector: 'clear',
            },
            {
                name: 'Ausgewählte löschen',
                selector: 'delete_selected',
            }
        
        ],

            isLoaded : false,
            isLoggedin: false,
            loginMessage: null,
            selectedRows: [],
            selectedDay: this.props.location.search.split('=')[1],
            cursor: 0
            
        }
    }

    deleteRecord(day, id, date, key, object){
        
        if(!window.confirm("Sind Sie sicher?")){
            return;
        }

        console.log(object)

        // Delete performing
        object.splice(key, 1);

        var cityRef = auth.firestore().collection(day).doc(id);

        // Remove the 'capital' field from the document
        var removeCapital = cityRef.update({
            [date]: object
        }).then(()=>{
            // refresh the list
             this.showData(day);
        });

        
    }


    // This method is recursive method
    // It call it self, depending on cursor

    deleteBulkRecord( ){

        let CL = this;

        // immediately stop if there is no selection
        if(this.state.selectedRows.length == 0 ){
            alert('Bitte zuerst die Zeilen auswählen!');
            return;
        }
        

        // select first row from the selected rows
        let row = this.state.selectedRows[CL.state.cursor];
        const DAY = row.day;

        // Loop through database
        auth.firestore().collection(DAY).get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots

                try{

                let object = doc.data()[row.date];
                let key = -1;

                //search for the key
                for(let i=0; i < object.length; i++){
                    
                    if(row.id == object[i].id){
                        key = i;
                        break; // immediately stop if key is found
                    }
                }

                    
                    if(key != -1){
                    // Performing deletion after getting object and key
                    object.splice(key, 1); // delete data from the object

                    let id = row.time;
                    var cityRef = auth.firestore().collection(DAY).doc(id); // get the reference

                    //Remove the 'capital' field from the document
                    var removeCapital = cityRef.update({
                        [row.date]: object // new object has been replaced
                    }).then((values) => {
                        // Increment cursor once one of the row has been deleted
                        CL.setState({
                            cursor: CL.state.cursor + 1
                        });

                        // Refresh the list
                        CL.showData(DAY);

                        // If the cursor is less than the selected items then perform recursion
                        if(CL.state.cursor < CL.state.selectedRows.length){
                            console.log("I was there")
                            CL.deleteBulkRecord();
                        }else{
                            // otherwise set cursor to 0 for new deletion action
                            CL.setState({
                                cursor: 0
                            });
                        }
                        
                    })
                    }


                }catch(e){
                    console.log("ignored")
                }
                    
                });
        });
                    


        // setTimeout(()=>{
        //     window.location.assign('/dashboard?day='+ this.state.selectedDay)
        // },2000)
    }



    showData(day){

        let CL = this;

        //Reset the state
        CL.setState({
            data:[]
        })

        if(day=="") return;

        // add selected day to the state
        this.setState({
            selectedDay : day
        });

        auth.firestore().collection(day).get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                
                let object = doc.data();

                console.log(doc.id, "=>", doc.data())
                
                for (const key in object) {
                    if (object.hasOwnProperty(key)) {
                        
                        if(Array.isArray(object[key])){

                            // now loop through the array

                            for(let i = 0; i < object[key].length; i++){
                                CL.setState({
                                    data:[
                                        ...CL.state.data,
                                        {
                                            date: key, 
                                            day, 
                                            title: object.title, 
                                            time:doc.id, 
                                            name: object[key][i]['name'], 
                                            email: object[key][i]['email'], 
                                            id: object[key][i]['id'], 
                                            action: <button className="btn btn-danger" onClick={()=>{CL.deleteRecord(day, doc.id, key, i, object[key])}}>Löschen</button> 
                                        }
                                    
                                    ]
                                })
                            }
                            
                            
                            
                        }
                        
                    }
                }
            });
        });   
    }



    componentDidMount(){
        const CL = this;

        console.log(this.props)

        auth.auth().onAuthStateChanged((user) => {
            if (user) {
            
              var uid = user.uid;
              console.log("user logged in", uid)

              // role check
              var docRef = auth.firestore().collection("users").doc(uid);
                docRef.get().then(function(doc) {
                    if (doc.exists) {
                        
                        if(doc.data().role == "admin"){
                            CL.setState({
                                isLoggedin: true
                            });
                            CL.showData(CL.state.selectedDay)
                        }else{
                            // signout
                            SignOutDirect();

                            CL.setState({
                                isLoggedin: false,
                                loginMessage: "Entschuldigung, Sie haben keine Erlaubnis"
                            });
                        }

                        
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });

              
              
            } else {
                CL.setState({
                    isLoggedin: false
                });
            }


            // checking finished
            CL.setState({
                isLoaded: true
            });
          });

    }

    render() {
       
        if(!this.state.isLoaded) {
            return <div></div>;
        }

        if(this.state.isLoggedin){
            return (
                <div id="everything">
                    <div className="container-fluid">
                        <div className="row">
    
                            <div className="col-12 py-2">
                                 <div className="form-group">
                                    <select className="form-control" onChange={(e)=>{ this.showData(e.target.value)}} name="" id="">
                                            <option value="">Bitte Wähle</option>
                                            <option value="Samstag" selected={this.state.selectedDay == 'Samstag'}>Samstag</option>
                                            <option value="Sonntag" selected={this.state.selectedDay == 'Sonntag'}>Sonntag</option>
                                            <option value="Montag" selected={this.state.selectedDay == 'Montag'}>Montag</option>
                                            <option value="Dienstag" selected={this.state.selectedDay == 'Dienstag'}>Dienstag</option>
                                            <option value="Mittwoch" selected={this.state.selectedDay == 'Mittwoch'}>Mittwoch</option>
                                            <option value="Donnerstag" selected={this.state.selectedDay == 'Donnerstag'}>Donnerstag</option>
                                            <option value="Freitag" selected={this.state.selectedDay == 'Freitag'}>Freitag</option>
                                        </select>
                                </div>
                            </div>
                            
                        </div>

                        <DataTable
                            title="Daten verwalten"
                            columns={this.state.columns}
                            data = {this.state.data}
                            selectableRows
                            selectableRowsComponent={Checkbox}
                            selectableRowsHighlight = {true}
                            selectableRowsComponentProps={selectProps}
                            onSelectedRowsChange={(e)=>{this.setState({selectedRows: e.selectedRows})}}
                        />

                        <div className="logout">
                             <SignOut />
                        </div>
                    </div>

                    
                </div>
            )
        }else{
            return <SignIn message={this.state.loginMessage} />
        }
          
        
    }
}

export default Dashboard
